import { render, staticRenderFns } from "./BoothAd.vue?vue&type=template&id=67784670&scoped=true"
import script from "./BoothAd.vue?vue&type=script&lang=js"
export * from "./BoothAd.vue?vue&type=script&lang=js"
import style0 from "./BoothAd.vue?vue&type=style&index=0&id=67784670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67784670",
  null
  
)

export default component.exports